import { CategoryArray } from './types'

export const sortCategories = (categories: CategoryArray) => {
  const visible: CategoryArray = categories.filter((c) => c.showInList)
  return visible.sort((a, b) => (a.position > b.position ? 1 : b.position > a.position ? -1 : 0))
}
